import { apiHttpService } from './apiHttpService';
import { Test, TestResults } from '../domains/results';
import { DropdownResponse, ListResponse } from '../domains/app';

export const fetchUserExercise = (
  personId: string[],
): Promise<DropdownResponse[]> => {
  return apiHttpService
    .get(`/api/Result/testtype`, { params: { personId } })
    .then((response) => response.data);
};

export const fetchListTests = (
  exerciseId: string,
  personId: string,
  testDefinition?: string,
): Promise<ListResponse<Test>> => {
  return apiHttpService
    .get(
      `/api/Result/test?testTypeId=${exerciseId}&personId=${personId}&pageSize=1000&page=0${
        testDefinition ? `&testDefinition=${testDefinition}` : ``
      }`,
    )
    .then((response) => {
      response.data.items = response.data.items.map((d: Test) => ({
        ...d,
        checked: false,
        person: {
          ...d.person,
          fullName: `${d.person.firstName} ${d.person.lastName}`,
        },
      }));
      return response.data;
    });
};

export const fetchListTestsForValid = (
  pageSize: number,
  page: number,
  search?: string,
): Promise<ListResponse<Test>> => {
  return apiHttpService
    .get(
      `/api/Result/test?pageSize=${pageSize}&page=${page}${
        search ? `&searchValue=${search}` : ``
      }`,
    )
    .then((response) => {
      response.data.items = response.data.items.map((d: Test) => ({
        ...d,
        checked: false,
      }));
      return response.data;
    });
};

export const fetchTestResults = (
  testId: string,
  languageId: string,
): Promise<TestResults> => {
  return apiHttpService
    .get(`/api/Result/test/${testId}/data?languageId=${languageId}`)
    .then((response) => {
      response.data.id = testId;
      return response.data;
    });
};

export const toggleTestValidity = (testId: string): Promise<TestResults> => {
  return apiHttpService
    .post(`/api/Result/test/${testId}/invalidate`)
    .then((response) => response.data);
};

export const deleteTest = (testId: string): Promise<TestResults> => {
  return apiHttpService
    .delete(`/api/Result/test/${testId}`)
    .then((response) => response.data);
};

export const deleteTestType = (id: string): Promise<DropdownResponse> => {
  return apiHttpService
    .delete(`/api/Result/testtype/${id}`)
    .then((response) => response.data);
};

export const createTestType = (name: string): Promise<DropdownResponse> => {
  return apiHttpService
    .post(`/api/Result/testtype?testType=${name}`)
    .then((response) => response.data);
};

export const updateTestType = (
  id: string,
  name: string,
): Promise<DropdownResponse> => {
  return apiHttpService
    .patch(`/api/Result/testtype/${id}?testType=${name}`)
    .then((response) => response.data);
};

export const getTestTypesByPersons = (
  userIds: string[],
): Promise<DropdownResponse[]> => {
  return apiHttpService
    .post(`/api/Result/test/testtype/bypersons`, userIds)
    .then((response) => response.data);
};

// eslint-disable-next-line
export default {
  fetchUserExercise,
  fetchTestResults,
  fetchListTests,
  fetchListTestsForValid,
  toggleTestValidity,
  deleteTest,
  deleteTestType,
  createTestType,
  updateTestType,
  getTestTypesByPersons,
};
